export const MEDIA_NODES_FETCH_SUCCESS = 'MEDIA_NODES_FETCH_SUCCESS';
export const MEDIA_NODES_FETCH_IN_PROGRESS = 'MEDIA_NODES_FETCH_IN_PROGRESS';
export const MEDIA_NODES_FETCH_ERROR = 'MEDIA_NODES_FETCH_ERROR';

export const MEDIA_NODE_DETAILS_FETCH_SUCCESS = 'MEDIA_NODE_DETAILS_FETCH_SUCCESS';
export const MEDIA_NODE_DETAILS_FETCH_IN_PROGRESS = 'MEDIA_NODE_DETAILS_FETCH_IN_PROGRESS';
export const MEDIA_NODE_DETAILS_FETCH_ERROR = 'MEDIA_NODE_DETAILS_FETCH_ERROR';
export const MEDIA_NODE_DETAILS_SET = 'MEDIA_NODE_DETAILS_SET';

export const ADD_MEDIA_NODE_SUCCESS = 'ADD_MEDIA_NODE_SUCCESS';
export const ADD_MEDIA_NODE_IN_PROGRESS = 'ADD_MEDIA_NODE_IN_PROGRESS';
export const ADD_MEDIA_NODE_ERROR = 'ADD_MEDIA_NODE_ERROR';

export const UPDATE_MEDIA_NODE_SUCCESS = 'UPDATE_MEDIA_NODE_SUCCESS';
export const UPDATE_MEDIA_NODE_IN_PROGRESS = 'UPDATE_MEDIA_NODE_IN_PROGRESS';
export const UPDATE_MEDIA_NODE_ERROR = 'UPDATE_MEDIA_NODE_ERROR';

export const DELETE_MEDIA_NODE_SUCCESS = 'DELETE_MEDIA_NODE_SUCCESS';
export const DELETE_MEDIA_NODE_IN_PROGRESS = 'DELETE_MEDIA_NODE_IN_PROGRESS';
export const DELETE_MEDIA_NODE_ERROR = 'DELETE_MEDIA_NODE_ERROR';

export const ADD_MEDIA_NODE_DIALOG_SHOW = 'ADD_MEDIA_NODE_DIALOG_SHOW';
export const ADD_MEDIA_NODE_DIALOG_HIDE = 'ADD_MEDIA_NODE_DIALOG_HIDE';
export const UPDATE_MEDIA_NODE_DIALOG_SHOW = 'UPDATE_MEDIA_NODE_DIALOG_SHOW';
export const UPDATE_MEDIA_NODE_DIALOG_HIDE = 'UPDATE_MEDIA_NODE_DIALOG_HIDE';
export const DELETE_MEDIA_NODE_DIALOG_SHOW = 'DELETE_MEDIA_NODE_DIALOG_SHOW';
export const DELETE_MEDIA_NODE_DIALOG_HIDE = 'DELETE_MEDIA_NODE_DIALOG_HIDE';

export const MEDIA_NODE_NAME_SET = 'MEDIA_NODE_NAME_SET';
export const MEDIA_NODE_ID_SET = 'MEDIA_NODE_ID_SET';
export const MEDIA_NODE_DESCRIPTION_SET = 'MEDIA_NODE_DESCRIPTION_SET';
export const MEDIA_NODE_URL_SET = 'MEDIA_NODE_URL_SET';
export const MEDIA_NODE_AUTH_TOKEN_SET = 'MEDIA_NODE_AUTH_TOKEN_SET';
export const MEDIA_NODE_UPLOAD_ACCESS_TOKEN_SET = 'MEDIA_NODE_UPLOAD_ACCESS_TOKEN_SET';

export const CONNECT_MEDIA_NODE_IN_PROGRESS = 'CONNECT_MEDIA_NODE_IN_PROGRESS';
export const CONNECT_MEDIA_NODE_SUCCESS = 'CONNECT_MEDIA_NODE_SUCCESS';
export const CONNECT_MEDIA_NODE_ERROR = 'CONNECT_MEDIA_NODE_ERROR';

export const VERIFY_MEDIA_NODE_IN_PROGRESS = 'VERIFY_MEDIA_NODE_IN_PROGRESS';
export const VERIFY_MEDIA_NODE_SUCCESS = 'VERIFY_MEDIA_NODE_SUCCESS';
export const VERIFY_MEDIA_NODE_ERROR = 'VERIFY_MEDIA_NODE_ERROR';

export const MEDIA_NODE_PROFILE_DETAILS_FETCH_IN_PROGRESS = 'MEDIA_NODE_PROFILE_DETAILS_FETCH_IN_PROGRESS';
export const MEDIA_NODE_PROFILE_DETAILS_FETCH_SUCCESS = 'MEDIA_NODE_PROFILE_DETAILS_FETCH_SUCCESS';
export const MEDIA_NODE_PROFILE_DETAILS_FETCH_ERROR = 'MEDIA_NODE_PROFILE_DETAILS_FETCH_ERROR';

export const MEDIA_NODE_ACCESS_TOKEN_FETCH_IN_PROGRESS = 'MEDIA_NODE_ACCESS_TOKEN_FETCH_IN_PROGRESS';
export const MEDIA_NODE_ACCESS_TOKEN_FETCH_SUCCESS = 'MEDIA_NODE_ACCESS_TOKEN_FETCH_SUCCESS';
export const MEDIA_NODE_ACCESS_TOKEN_FETCH_ERROR = 'MEDIA_NODE_ACCESS_TOKEN_FETCH_ERROR';

export const MEDIA_NODE_STATUS_FETCH_IN_PROGRESS = 'MEDIA_NODE_STATUS_FETCH_IN_PROGRESS';
export const MEDIA_NODE_STATUS_FETCH_SUCCESS = 'MEDIA_NODE_STATUS_FETCH_SUCCESS';
export const MEDIA_NODE_STATUS_FETCH_ERROR = 'MEDIA_NODE_STATUS_FETCH_ERROR';

export const LIVE_STREAM_ACCESS_TOKEN_FETCH_IN_PROGRESS = 'LIVE_STREAM_ACCESS_TOKEN_FETCH_IN_PROGRESS';
export const LIVE_STREAM_ACCESS_TOKEN_FETCH_SUCCESS = 'LIVE_STREAM_ACCESS_TOKEN_FETCH_SUCCESS';
export const LIVE_STREAM_ACCESS_TOKEN_FETCH_ERROR = 'LIVE_STREAM_ACCESS_TOKEN_FETCH_ERROR';

export const UPDATE_LIVE_STREAM_ACCESS_TOKEN_IN_PROGRESS = 'UPDATE_LIVE_STREAM_ACCESS_TOKEN_IN_PROGRESS';
export const UPDATE_LIVE_STREAM_ACCESS_TOKEN_SUCCESS = 'UPDATE_LIVE_STREAM_ACCESS_TOKEN_SUCCESS';
export const UPDATE_LIVE_STREAM_ACCESS_TOKEN_ERROR = 'UPDATE_LIVE_STREAM_ACCESS_TOKEN_ERROR';

export const CHANNEL_AUTH_ENABLE_IN_PROGRESS = 'CHANNEL_AUTH_ENABLE_IN_PROGRESS';
export const CHANNEL_AUTH_ENABLE_SUCCESS = 'CHANNEL_AUTH_ENABLE_SUCCESS';
export const CHANNEL_AUTH_ENABLE_ERROR = 'CHANNEL_AUTH_ENABLE_ERROR';

export const CHANNEL_AUTH_DISABLE_IN_PROGRESS = 'CHANNEL_AUTH_DISABLE_IN_PROGRESS';
export const CHANNEL_AUTH_DISABLE_SUCCESS = 'CHANNEL_AUTH_DISABLE_SUCCESS';
export const CHANNEL_AUTH_DISABLE_ERROR = 'CHANNEL_AUTH_DISABLE_ERROR';

export const UPDATE_LIVE_STREAM_ACCESS_TOKEN_DIALOG_SHOW = 'UPDATE_LIVE_STREAM_ACCESS_TOKEN_DIALOG_SHOW';
export const UPDATE_LIVE_STREAM_ACCESS_TOKEN_DIALOG_HIDE = 'UPDATE_LIVE_STREAM_ACCESS_TOKEN_DIALOG_HIDE';

export const O_AUTH_DIALOG_SHOW = 'O_AUTH_DIALOG_SHOW';
export const O_AUTH_DIALOG_HIDE = 'O_AUTH_DIALOG_HIDE';

export const YOUTUBE_O_AUTH_URL_FETCH_SUCCESS = 'YOUTUBE_O_AUTH_URL_FETCH_SUCCESS';
export const YOUTUBE_O_AUTH_URL_FETCH_IN_PROGRESS = 'YOUTUBE_O_AUTH_URL_FETCH_IN_PROGRESS';
export const YOUTUBE_O_AUTH_URL_FETCH_ERROR = 'YOUTUBE_O_AUTH_URL_FETCH_ERROR';

export const YOUTUBE_O_AUTH_CALLBACK_FETCH_SUCCESS = 'YOUTUBE_O_AUTH_CALLBACK_FETCH_SUCCESS';
export const YOUTUBE_O_AUTH_CALLBACK_FETCH_IN_PROGRESS = 'YOUTUBE_O_AUTH_CALLBACK_FETCH_IN_PROGRESS';
export const YOUTUBE_O_AUTH_CALLBACK_FETCH_ERROR = 'YOUTUBE_O_AUTH_CALLBACK_FETCH_ERROR';

export const TWITCH_O_AUTH_URL_FETCH_SUCCESS = 'TWITCH_O_AUTH_URL_FETCH_SUCCESS';
export const TWITCH_O_AUTH_URL_FETCH_IN_PROGRESS = 'TWITCH_O_AUTH_URL_FETCH_IN_PROGRESS';
export const TWITCH_O_AUTH_URL_FETCH_ERROR = 'TWITCH_O_AUTH_URL_FETCH_ERROR';

export const TWITCH_O_AUTH_CALLBACK_FETCH_SUCCESS = 'TWITCH_O_AUTH_CALLBACK_FETCH_SUCCESS';
export const TWITCH_O_AUTH_CALLBACK_FETCH_IN_PROGRESS = 'TWITCH_O_AUTH_CALLBACK_FETCH_IN_PROGRESS';
export const TWITCH_O_AUTH_CALLBACK_FETCH_ERROR = 'TWITCH_O_AUTH_CALLBACK_FETCH_ERROR';

export const FACEBOOK_O_AUTH_URL_FETCH_SUCCESS = 'FACEBOOK_O_AUTH_URL_FETCH_SUCCESS';
export const FACEBOOK_O_AUTH_URL_FETCH_IN_PROGRESS = 'FACEBOOK_O_AUTH_URL_FETCH_IN_PROGRESS';
export const FACEBOOK_O_AUTH_URL_FETCH_ERROR = 'FACEBOOK_O_AUTH_URL_FETCH_ERROR';

export const FACEBOOK_O_AUTH_CALLBACK_FETCH_SUCCESS = 'FACEBOOK_O_AUTH_CALLBACK_FETCH_SUCCESS';
export const FACEBOOK_O_AUTH_CALLBACK_FETCH_IN_PROGRESS = 'FACEBOOK_O_AUTH_CALLBACK_FETCH_IN_PROGRESS';
export const FACEBOOK_O_AUTH_CALLBACK_FETCH_ERROR = 'FACEBOOK_O_AUTH_CALLBACK_FETCH_ERROR';

export const MEDIA_NODE_CHECK_CONFIG_FETCH_SUCCESS = 'MEDIA_NODE_CHECK_CONFIG_FETCH_SUCCESS';
export const MEDIA_NODE_CHECK_CONFIG_FETCH_IN_PROGRESS = 'MEDIA_NODE_CHECK_CONFIG_FETCH_IN_PROGRESS';
export const MEDIA_NODE_CHECK_CONFIG_FETCH_ERROR = 'MEDIA_NODE_CHECK_CONFIG_FETCH_ERROR';

export const MEDIA_NODE_ASSETS_LIST_FETCH_SUCCESS = 'MEDIA_NODE_ASSETS_LIST_FETCH_SUCCESS';
export const MEDIA_NODE_ASSETS_LIST_FETCH_IN_PROGRESS = 'MEDIA_NODE_ASSETS_LIST_FETCH_IN_PROGRESS';
export const MEDIA_NODE_ASSETS_LIST_FETCH_ERROR = 'MEDIA_NODE_ASSETS_LIST_FETCH_ERROR';

export const MEDIA_NODE_CATEGORIES_LIST_FETCH_SUCCESS = 'MEDIA_NODE_CATEGORIES_LIST_FETCH_SUCCESS';
export const MEDIA_NODE_CATEGORIES_LIST_FETCH_IN_PROGRESS = 'MEDIA_NODE_CATEGORIES_LIST_FETCH_IN_PROGRESS';
export const MEDIA_NODE_CATEGORIES_LIST_FETCH_ERROR = 'MEDIA_NODE_CATEGORIES_LIST_FETCH_ERROR';
export const MEDIA_NODE_CATEGORIE_VALUE_SET = 'MEDIA_NODE_CATEGORIE_VALUE_SET';

export const MEDIA_NODE_ASSET_DELETE_SUCCESS = 'MEDIA_NODE_ASSET_DELETE_SUCCESS';
export const MEDIA_NODE_ASSET_DELETE_IN_PROGRESS = 'MEDIA_NODE_ASSET_DELETE_IN_PROGRESS';
export const MEDIA_NODE_ASSET_DELETE_ERROR = 'MEDIA_NODE_ASSET_DELETE_ERROR';
export const MEDIA_NODE_ASSET_DELETE_DIALOG_SHOW = 'MEDIA_NODE_ASSET_DELETE_DIALOG_SHOW';
export const MEDIA_NODE_ASSET_DELETE_DIALOG_HIDE = 'MEDIA_NODE_ASSET_DELETE_DIALOG_HIDE';

export const UPLOAD_MEDIA_NODE_ASSET_FILE_ERROR_MESSAGE_SET = 'UPLOAD_MEDIA_NODE_ASSET_FILE_ERROR_MESSAGE_SET';
export const UPLOAD_MEDIA_NODE_ASSET_FILE_CANCEL_SET = 'UPLOAD_MEDIA_NODE_ASSET_FILE_CANCEL_SET';
export const MEDIA_NODE_ASSET_UPLOAD_SET = 'MEDIA_NODE_ASSET_UPLOAD_SET';
export const MEDIA_NODE_ASSET_UPLOAD_PROGRESS_SET = 'MEDIA_NODE_ASSET_UPLOAD_PROGRESS_SET';
export const MEDIA_NODE_ASSET_UPLOAD_CANCEL_SET = 'MEDIA_NODE_ASSET_UPLOAD_CANCEL_SET';
export const MEDIA_NODE_ASSET_UPLOAD_SUCCESS = 'MEDIA_NODE_ASSET_UPLOAD_SUCCESS';
export const MEDIA_NODE_ASSET_UPLOAD_IN_PROGRESS = 'MEDIA_NODE_ASSET_UPLOAD_IN_PROGRESS';
export const MEDIA_NODE_ASSET_UPLOAD_ERROR = 'MEDIA_NODE_ASSET_UPLOAD_ERROR';
export const MEDIA_NODE_ASSET_UPLOAD_VALUE_SET = 'MEDIA_NODE_ASSET_UPLOAD_VALUE_SET';
export const MEDIA_NODE_ASSET_UPLOAD_DIALOG_SHOW = 'MEDIA_NODE_ASSET_UPLOAD_DIALOG_SHOW';
export const MEDIA_NODE_ASSET_UPLOAD_DIALOG_HIDE = 'MEDIA_NODE_ASSET_UPLOAD_DIALOG_HIDE';

export const UPLOAD_MEDIA_NODE_CATEGORY_SUCCESS = 'UPLOAD_MEDIA_NODE_CATEGORY_SUCCESS';
export const UPLOAD_MEDIA_NODE_CATEGORY_IN_PROGRESS = 'UPLOAD_MEDIA_NODE_CATEGORY_IN_PROGRESS';
export const UPLOAD_MEDIA_NODE_CATEGORY_ERROR = 'UPLOAD_MEDIA_NODE_CATEGORY_ERROR';

export const MEDIA_NODE_EDIT_DIALOG_SHOW = 'MEDIA_NODE_EDIT_DIALOG_SHOW';
export const MEDIA_NODE_EDIT_DIALOG_HIDE = 'MEDIA_NODE_EDIT_DIALOG_HIDE';

// Authorize Media Node
export const AUTHORIZE_MEDIA_NODE_SUCCESS = 'AUTHORIZE_MEDIA_NODE_SUCCESS';
export const AUTHORIZE_MEDIA_NODE_IN_PROGRESS = 'AUTHORIZE_MEDIA_NODE_IN_PROGRESS';
export const AUTHORIZE_MEDIA_NODE_ERROR = 'AUTHORIZE_MEDIA_NODE_ERROR';
